import { rootApi } from '@/store/api'
import { UpdateCustomerProfileDTO } from '@/features/profile/types'
import { UserDTO } from '@/features/user/types'

export const profileApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    profileUpdateCustomerProfile: builder.mutation<UserDTO, UpdateCustomerProfileDTO>({
      query: (arg) => ({
        url: 'profile/customer',
        method: 'POST',
        body: arg,
      }),
      // async onQueryStarted(id, { dispatch, queryFulfilled }) {
      //   const data = await queryFulfilled
      //   dispatch(userData.updateData(data.data))
      // },
      transformResponse: (response: any) => {
        return response?.data
      },
    }),
    profileUpdatePassword: builder.mutation<any, any>({
      query: (arg) => ({
        url: 'profile/password',
        method: 'POST',
        body: arg,
      }),
    }),
    profileDelete: builder.mutation<void, void>({
      query: () => ({
        url: 'profile/delete',
        method: 'POST',
      }),
    }),
  }),
  overrideExisting: false,
})

export const {
  useProfileUpdateCustomerProfileMutation,
  useProfileUpdatePasswordMutation,
  useProfileDeleteMutation,
} = profileApi
